var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.overlay__share},[_c('van-overlay',{attrs:{"show":_vm.show,"duration":"0.05"},on:{"click":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }